// Home.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { baseApiURL } from "../../baseUrl";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Notice from "../../components/Notice";
import Profile from "./Profile";
import Timetable from "./Timetable";
import { Toaster } from "react-hot-toast";
import Material from "./Material";
import Marks from "./Marks";
import Student from "./Student";
import Attendence from "./Attendence";
import EditFaculty from "./EditFaculty";
import FinalCOPOAttainment from "./FinalCOPOAttainment";
import MyFacultyTimeTable from "./MyFacultyTimeTable";
import FacultyLeaveManagement from "./FacultyLeaveManagement";
import DailyAttendance from "./DailyAttendance";
import AIAssistant from "../Student/AIAssistant";
import AIAnalytics from "./AIAnalytics";
import MessageParent from "../../components/MessageParent";
import FacultyOBEConfig from "./FacultyOBEConfig";
import PredictiveAnalytics from "../Admin/PredictiveAnalytics";
import StudentDSAReports from "./StudentDSAReports";
import NoticeTicker from "../../components/NoticeTicker";

const Home = () => {
  const router = useLocation();
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState("My Profile");
  const [load, setLoad] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [targetRollNo, setTargetRollNo] = useState("");

  const [analyticsData, setAnalyticsData] = useState({ stats: [], optionalLeave: { used: 0, available: 0 } });

  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (router.state === null && !activeToken) {
      navigate("/");
    }
    setLoad(true);
    if (router.state?.loginid || localStorage.getItem("loginid")) {
      fetchAnalytics();
    }

    // Listen for navbar profile click
    const handleOpenProfile = () => setSelectedMenu("My Profile");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem("token");
      const loginId = router.state?.loginid || localStorage.getItem("loginid");
      const response = await axios.get(`${baseApiURL()}/accounts/attendance/stats/${loginId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setAnalyticsData({
          stats: response.data.stats || [],
          optionalLeave: response.data.optionalLeave || { used: 0, available: 0 }
        });
      }
    } catch (error) {
      console.error("Error fetching analytics:", error);
    }
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case "My Profile":
        return <Profile />;
      case "Student DSA Reports":
        return <StudentDSAReports />;
      case "Student Info":
        return <Student onMessageParent={(roll) => { setTargetRollNo(roll); setSelectedMenu("Message Parent"); }} />;
      case "Upload Marks":
        return <Marks />;
      case "Message Parent":
        return <MessageParent userType="Faculty" currentUser={router.state} initialEnrollmentNo={targetRollNo} />;
      case "Timetable":
        return <Timetable />;
      case "MyFacultyTimeTable":
        return <MyFacultyTimeTable />;
      case "Notice":
        return <Notice />;
      case "Material":
        return <Material />;
      case "Attendence":
        return <Attendence />;
      case "Edit Faculty":
        return <EditFaculty />;
      case "Final CO/PO Attainment":
        return <FinalCOPOAttainment />;
      case "CO-PO Mapping":
      case "OBE Config":
        return <FacultyOBEConfig />;
      case "Leave Management":
        return <FacultyLeaveManagement setSelectedMenu={setSelectedMenu} />;
      case "DailyAttendance":
        return <DailyAttendance />;
      case "AI Assistant":
        return <AIAssistant />;
      case "AI Student Analytics":
        return <AIAnalytics />;
      case "PredictiveAnalytics":
        return <PredictiveAnalytics />;
      default:
        return <Profile />;
    }
  };

  return (
    <>
      {load && (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
          <Navbar />
          <Sidebar
            selectedMenu={selectedMenu}
            setSelectedMenu={setSelectedMenu}
            userType="Faculty"
            isCollapsed={isSidebarCollapsed}
            setIsCollapsed={setIsSidebarCollapsed}
          />

          {/* Main Content Area */}
          <div className={`transition-all duration-300 ${isSidebarCollapsed ? "md:ml-16 w-full md:w-[calc(100%-4rem)]" : "md:ml-64 w-full md:w-[calc(100%-16rem)]"} ml-0 min-h-[calc(100vh-4rem)]`}>
            <div className="p-4 md:p-6 lg:p-8 w-full space-y-6">
              {/* Bento Dashboard Section on Profile */}
              {selectedMenu === "My Profile" && (
                <div className="space-y-6 mb-8">
                  {/* Hero Bento Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                    {/* Hero Banner (Spans 2 cols) */}
                    <div className="md:col-span-2 lg:col-span-2 rounded-2xl bg-white dark:bg-slate-900 p-6 text-slate-900 dark:text-white relative overflow-hidden flex flex-col justify-between min-h-[180px] border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-xl">
                      <div>
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-indigo-50 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-300 border border-indigo-100 dark:border-indigo-500/40 mb-3 shadow-xs">
                          <span className="w-2 h-2 rounded-full bg-emerald-500 dark:bg-emerald-400 mr-2 animate-pulse"></span>
                          Faculty Academic Hub
                        </span>
                        <h1 className="text-xl md:text-2xl font-black tracking-tight">Sphoorthy Engineering College</h1>
                        <p className="text-slate-500 dark:text-slate-400 text-xs md:text-sm font-semibold mt-1">Teaching & Course Outcome Management Portal</p>
                      </div>
                      <div className="flex flex-wrap items-center space-x-3 pt-4 border-t border-slate-200 dark:border-slate-800 mt-4 text-xs font-semibold text-slate-600 dark:text-slate-300">
                        <span className="text-slate-400">Quick Actions</span>
                        <span className="text-slate-400">•</span>
                        <button onClick={() => setSelectedMenu("Attendence")} className="text-indigo-600 dark:text-indigo-400 hover:underline transition-colors cursor-pointer font-bold">Attendance</button>
                        <span className="text-slate-400">•</span>
                        <button onClick={() => setSelectedMenu("Upload Marks")} className="text-indigo-600 dark:text-indigo-400 hover:underline transition-colors cursor-pointer font-bold">Upload Marks</button>
                        <span className="text-slate-400">•</span>
                        <button onClick={() => setSelectedMenu("Student DSA Reports")} className="text-amber-600 dark:text-amber-400 hover:underline transition-colors cursor-pointer font-bold">Student DSA Reports</button>
                      </div>
                    </div>

                    {/* Quick Stat Card 1: Attendance */}
                    <div 
                      onClick={() => setSelectedMenu("Attendence")}
                      className="rounded-2xl p-5 flex flex-col justify-between bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md hover:border-indigo-500/50 cursor-pointer transition-all"
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Attendance</span>
                        <div className="w-9 h-9 bg-indigo-50 dark:bg-indigo-500/10 rounded-xl flex items-center justify-center text-indigo-600 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-500/20">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                          </svg>
                        </div>
                      </div>
                      <div className="mt-4">
                        <p className="text-lg font-bold text-slate-900 dark:text-white">Mark & Track</p>
                        <p className="text-[11px] text-emerald-600 dark:text-emerald-400 font-medium mt-1">✓ Student Attendance</p>
                      </div>
                    </div>

                    {/* Quick Stat Card 2: Student DSA Reports */}
                    <div 
                      onClick={() => setSelectedMenu("Student DSA Reports")}
                      className="rounded-2xl p-5 flex flex-col justify-between bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md hover:border-amber-500/50 cursor-pointer transition-all"
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">DSA Progress</span>
                        <div className="w-9 h-9 bg-amber-50 dark:bg-amber-500/10 rounded-xl flex items-center justify-center text-amber-600 dark:text-amber-400 border border-amber-200 dark:border-amber-500/20">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="mt-4">
                        <p className="text-lg font-bold text-slate-900 dark:text-white">DSA Sheet Reports</p>
                        <p className="text-[11px] text-amber-600 dark:text-amber-400 font-medium mt-1">✓ Track Solved Questions</p>
                      </div>
                    </div>
                  </div>

                  {/* Attendance Analytics Grid */}
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
                    <div className="lg:col-span-2 rounded-2xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md">
                      <h3 className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-4">Monthly Attendance Trend</h3>
                      <div className="h-44 flex items-end justify-between px-4">
                        {analyticsData.stats.length === 0 ? (
                          <div className="w-full text-center text-slate-400 dark:text-slate-500 text-sm py-10 italic">No attendance records found yet.</div>
                        ) : (
                          analyticsData.stats.map((s, i) => (
                            <div key={i} className="flex flex-col items-center group flex-1 h-full justify-end px-1">
                              <div className="w-full h-full flex items-end justify-center relative min-h-[140px]">
                                <div className="w-full max-w-[28px] bg-slate-100 dark:bg-slate-800 rounded-t-lg h-full absolute bottom-0 opacity-50"></div>
                                <div 
                                  className="w-full max-w-[28px] bg-indigo-600 dark:bg-indigo-500 rounded-t-lg transition-all group-hover:bg-indigo-700 dark:group-hover:bg-indigo-400 relative z-10 shadow-xs" 
                                  style={{ height: `${Math.max(s.percentage, 5)}%` }}
                                >
                                  <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-slate-800 dark:bg-slate-950 text-white text-[10px] px-2 py-1 rounded border border-slate-700 dark:border-slate-800 shadow-lg opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap z-30 pointer-events-none">
                                    <div className="font-bold">{s.month}: {s.percentage}%</div>
                                    <div className="text-[9px] text-slate-300 dark:text-slate-400">{s.presentDays}/{s.totalDays} Days</div>
                                  </div>
                                </div>
                              </div>
                              <span className="text-[10px] mt-2 font-bold text-slate-500 dark:text-slate-400 uppercase">{s.month}</span>
                            </div>
                          ))
                        )}
                      </div>
                    </div>

                    {/* Optional Leaves Card */}
                    <div className="rounded-2xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md flex items-center justify-between">
                      <div>
                        <h3 className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">Optional Leaves</h3>
                        <p className="text-3xl font-extrabold text-indigo-600 dark:text-indigo-400">
                          {analyticsData.optionalLeave.used} / {analyticsData.optionalLeave.available}
                        </p>
                        <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Used vs Available</p>
                        <button 
                          onClick={() => setSelectedMenu("Leave Management")} 
                          className="mt-4 px-3.5 py-1.5 text-xs font-bold text-indigo-600 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-500/20 hover:bg-indigo-100 dark:hover:bg-indigo-500/30 rounded-lg transition-colors border border-indigo-200 dark:border-indigo-500/30 cursor-pointer"
                        >
                          Apply Leave
                        </button>
                      </div>
                      <div className="w-28 h-28 rounded-full border-[10px] border-indigo-600 dark:border-indigo-500 relative flex items-center justify-center shadow-inner">
                        <span className="text-xs font-bold text-slate-900 dark:text-white">
                          {analyticsData.optionalLeave.available > 0 ? Math.round((analyticsData.optionalLeave.used / analyticsData.optionalLeave.available) * 100) : 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Main Active Menu Content */}
              <div className="w-full">
                {renderContent()}
              </div>

            </div>
          </div>
        </div>
      )}
      <Toaster position="top-center" />
    </>
  );
};

export default Home;